import React from 'react';
import styles from './DescriptionList.css'
import {TypeDescriptionList} from "../../constants/consts-prop-types"
import PropTypes from "prop-types"
import {autoFormatter, hasExpiredEvent, hasExpiredAllEvents} from '../../services/service-auto-formatter'

const DescriptionData = props => {
  if(!props.item) return null

  // Event with end-time date:
  if(props.item.text && props.item.endtime) {
    const expired = hasExpiredEvent(props.item.endtime)

    return <dd
      dangerouslySetInnerHTML={{__html: props.item.text}}
      className={expired ? styles.eventTimeExpired : styles.eventTime}
    />
  }

  // Generic data-value:
  return <dd
    dangerouslySetInnerHTML={{__html: autoFormatter(props.item)}}
  />
}

const DescriptionList = props => {
  const {header, values} = props.data

  const hasExpiredAll = hasExpiredAllEvents(values)

  return (
    <dl>
      <dt className={hasExpiredAll ? styles.dlExpired : styles.dl}>{header}</dt>
      {values &&
      values.map((item, idx) => <DescriptionData key={idx} item={item}/>)
      }
    </dl>
  )
}

const DescriptionListsContainer = props => {
  const {items} = props
  if(!items) return null

  return (
    <div className={styles.DescriptionLists}>
      {
        items.map((listData, idx) => <DescriptionList key={idx} data={listData}/>)
      }
    </div>
  )
}

DescriptionListsContainer.propTypes = {
  items: PropTypes.arrayOf(TypeDescriptionList),
}

export default DescriptionListsContainer;



// WEBPACK FOOTER //
// ./src/components/DescriptionLists/DescriptionListsContainer.js